import ClassSubjectCombobox from './ClassSubjectCombobox';
export default ClassSubjectCombobox;
